import { FC, useEffect, useState } from "react";
import { withProcedureWraper } from "../..";
import { Box } from "../../../../components/box";
import { Icon } from "../../../../components/icon";
import CreateRequestButton from "../../components/CreateRequestButton";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../AppRoutes";
import { useSelector } from "../../../../store/store";
import { PlanningDepartmentRecallToolService } from "../../../../services/planning-department/recall-tool";
import { RequestList } from "./components/my-requests";
import { ApprovalList } from "./components/my-approvals";

export const procedureRecallTool: FC = withProcedureWraper(() => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const history = useHistory();

  const [myRequests, setMyRequests] = useState([]);
  const [myApprovals, setMyApprovals] = useState([]);

  const getMyRequests = async () => {
    const resp = await PlanningDepartmentRecallToolService.getMyRequests({
      email: currentUserName,
    });
    setMyRequests(resp);
  };
  const getMyApproval = async () => {
    const resp = await PlanningDepartmentRecallToolService.getMyApproval({
      email: currentUserName,
    });
    setMyApprovals(resp);
  };

  useEffect(() => {
    getMyRequests();
    getMyApproval();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="ITCodeGrantedPage">
      <div className="pd15">
        <div
          className="text-md-left font-weight-normal p-3 bg-info text-white"
          style={{ fontSize: "14px" }}
        >
          <div className="row title__process-container">
            <div className="">
              <span className="icon__title-process">
                <Icon.DeleteBin5Line />
              </span>
              THU HỒI CCDC
            </div>
          </div>
        </div>

        <Box
          title="Yêu cầu của tôi"
          titleRight={
            <CreateRequestButton
              onClick={() =>
                history.push(Routes.createRecall.path.replace(":id", "0"))
              }
            />
          }
        >
          <RequestList dataSource={myRequests} />
        </Box>

        <Box title="Các yêu cầu cần duyệt">
          <ApprovalList dataSource={myApprovals} />
        </Box>
      </div>
    </div>
  );
});
